import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import IssuesViewTabs, { issuesViewFrom } from 'features/agent-analytics/components/IssuesViewTabs';
import FailuresView from 'features/agent-analytics/components/failures/FailuresView';
import IssuesList from 'features/issues/components/IssuesList';
import { useBreadcrumb } from 'shared/context/BreadcrumbContext';

function useSelectedTeam() {
  const [team, setTeam] = useState(() =>
    typeof window === 'undefined' ? '' : localStorage.getItem('selectedTeam') || ''
  );
  useEffect(() => {
    const onStorage = (e) => { if (e.key === 'selectedTeam') setTeam(e.newValue || ''); };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
  return team;
}

/**
 * Issues page — two views behind the top-bar switcher: Failures (hard failures
 * grouped by rule), the default, and tracked issues. `?tab=issues` picks the
 * second. A bare `?issue=<id>` link also opens Issues; the tab is written into
 * the URL so closing the drawer (which drops `issue`) stays on Issues.
 */
export default function IssuesPage() {
  const teamId = useSelectedTeam();
  const [searchParams, setSearchParams] = useSearchParams();
  const view = issuesViewFrom(searchParams);
  const needsTab = view === 'issues' && searchParams.get('tab') !== 'issues';
  useEffect(() => {
    if (!needsTab) return;
    const next = new URLSearchParams(searchParams);
    next.set('tab', 'issues');
    setSearchParams(next, { replace: true });
  }, [needsTab, searchParams, setSearchParams]);
  return (
    <>
      <IssuesViewTabs />
      {view === 'failures' ? <FailuresPane teamId={teamId} /> : <IssuesPane teamId={teamId} />}
    </>
  );
}

function IssuesPane({ teamId }) {
  useBreadcrumb([{ label: 'Issues' }]);
  return (
    <main className="flex h-full min-h-0 flex-col bg-surface" style={{ fontFamily: 'Inter, sans-serif' }}>
      <IssuesList teamId={teamId} />
    </main>
  );
}

function FailuresPane({ teamId }) {
  useBreadcrumb([{ label: 'Failures' }]);
  return (
    <main className="flex h-full min-h-0 flex-col bg-surface" style={{ fontFamily: 'Inter, sans-serif' }}>
      <FailuresView teamId={teamId} />
    </main>
  );
}
